export default __webpack_public_path__ + "static/media/banner_bg.1fda4d97.svg";